import React, { Component } from 'react';


class GuildProposal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            guildName: '',
            userName: '',
        };

        this.fetchGuildName();
        this.fetchUserName();
    }

    async fetchUserName() {
        let userName = await this.props.ethereum.users
            .getUserName(this.props.proposal.potentialMember);
        this.setState({userName: userName});
    }

    async fetchGuildName() {
        let guildName = await this.props.ethereum.guilds
            .getGuildName(this.props.guildId);
        this.setState({guildName: guildName});
    }

    accept() {
        // vote true on the proposal
        this.props.ethereum.guilds
            .voteForProposal(
                this.props.guildId,
                this.props.proposal.proposalIndex,
                true);
        this.props.onAccept();
    }

    reject() {
        // vote false on the proposal
        this.props.ethereum.guilds
            .voteForProposal(
                this.props.guildId,
                this.props.proposal.proposalIndex,
                false);
        this.props.onReject();
    }

    render() {
        return (
            <div className="new-member-request">
              <div className="user-field">
                <a className="user-hyperlink" href={"/user/" + this.state.userName}>{this.state.userName}</a>
              </div>
              <div className="action-description">
                requests to be added to the guild
              </div>
              <div className="guild-field">
                {this.state.guildName === '' ? this.props.guildId : this.state.guildName}
              </div>
              <div className="action-btns">
                <div
                  onClick={() => this.accept()}
                  className="common-button pink-button">ACCEPT</div>
                <div
                  onClick={() => this.reject()}
                  className="common-button pink-button">REJECT</div>
              </div>
            
            </div>
        );
    }
}

export default GuildProposal;
